import React from 'react';
import { motion } from 'framer-motion';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, subtitle, left, right, className = '' }: PageHeaderProps) {
  return (
    <motion.div
      className={[styles.header, className].filter(Boolean).join(' ')}
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
    >
      <div className={styles['title-group']}>
        {left}
        <div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>
      {right && <div className={styles.right}>{right}</div>}
    </motion.div>
  );
}
